import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DragulaService } from 'ng2-dragula';
import { InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { CosyDynaeditorControllerService } from 'src/app/service/controller/cosy-dynaeditor-controller.service';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';

//import * as _ from 'lodash';
import cloneDeep from 'lodash-es/cloneDeep';
@Component({
  selector: 'app-cosy-dynaeditor-formcontrol',
  templateUrl: './cosy-dynaeditor-formcontrol.component.html',
  styleUrls: ['../cosy-dynaeditor.component.css','./cosy-dynaeditor-formcontrol.component.css']
})
export class CosyDynaeditorFormcontrolComponent implements OnInit {
  @Input() dynaEditorElement:InterfaceElement;
  @Input() dynaItem:any;
  @Output() dynaItemChange = new EventEmitter();
  @Output() saveDEData = new EventEmitter();
 
  public ie: InterfaceElement;
  public ieNew : InterfaceElement;
  public availableControls: any[] = [];
  public visibleControls: any[] = [];
  public controlCode: string = 'C-';
  public dynaFormControlForm: any;
  public showFormControlDetail: boolean;
  public isAllowSort: boolean;
  public isVisible: boolean;
 

  constructor(private uxControllerService: UXControllerService,
    private cosyDynaeditorControllerService: CosyDynaeditorControllerService,
    private formBuilder: FormBuilder,
    private dragulaService: DragulaService) {
      dragulaService.drop("entity-items").subscribe(value => {
                 
        if (value.target.id == 'VisibleControls') {
          document.getElementById('C-' + value.el.id).style.visibility = 'visible';
        }
        if (value.target.id == 'AvailableControls') {
          document.getElementById('C-' + value.el.id).style.visibility = 'hidden';
        }
        this.cosyDynaeditorControllerService.dynaEditorProcessing(value, 'drag', this.dynaEditorElement['ie'], this.uxControllerService.cosyFormInitProperties);
       });
    }
  
  ngOnInit() {
    this.ie = this.dynaEditorElement['ie'];
    this.loadDynaEditorData();

  }

  updateFormValues(updatedDynaForm, actionType){
    this.saveDEData.emit(updatedDynaForm);
    this.showFormControlDetail = false;
  }

  loadDynaFormControlEditForm(item: any) {
    
    this.isAllowSort = false;
    this.isVisible = false;
    this.dynaFormControlForm = this.formBuilder.group({
        ID: [item.InterfaceElementID],
        displayName:[item.DisplayProperties.DisplayName],
        allowSort: [item.AllowSorting],
        name: [item.Name]
    }); 
 }

 editDynaControlEditorItem(dynaEditControl: any) {
  this.dynaItem = dynaEditControl;
  this.dynaItemChange.emit(this.dynaItem);
  this.loadDynaFormControlEditForm(dynaEditControl);
  this.showFormControlDetail = true;
}

 loadDynaEditorData(){
  this.visibleControls = [];
  this.availableControls = [];
  let ieIndex: number = -1;
  this.ieNew = new InterfaceElement();
  
  this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument =  cloneDeep(this.cosyDynaeditorControllerService.processedCASD)
  ieIndex = this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument.InterfaceElements.map(function (d) {
    return d['InterfaceElementID'];
  }).indexOf(this.ie.InterfaceElementID);

  for (let iee of this.ie.InterfaceElements) {
      if(iee.InterfaceElements == null){
        if(iee.Attributes.Active == null || iee.Attributes.Active == true){
          this.visibleControls.push(iee);
        } else{
          this.availableControls.push(iee);
        }
      } 
      else if(iee.InterfaceElements!= null){
        for(let ieee of iee.InterfaceElements){
          if(ieee.Attributes.Active == null || ieee.Attributes.Active == true){
            this.visibleControls.push(ieee);
          } else{
            this.availableControls.push(ieee);
          }
        }
      }
    }
    this.visibleControls.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);

    if (ieIndex < 0) {
      this.ieNew.InterfaceElementID = this.ie.InterfaceElementID;
      this.ieNew.InterfaceElements = [];
      this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument.InterfaceElements.push(this.ieNew);
     // this.cosyAppStateDataControllerService.processedCASD.InterfaceElements.push(this.ieNew);
      this.cosyDynaeditorControllerService.processedCASD.InterfaceElements.push(this.ieNew);
    }
  }
}
